import { Controller } from '@hotwired/stimulus';

export default class VideoSoundController extends Controller<HTMLElement> {
  static targets = ['video', 'button'];

  declare readonly videoTarget: HTMLVideoElement;

  declare readonly buttonTarget: HTMLButtonElement;

  toggle(): void {
    this.videoTarget.muted = !this.videoTarget.muted;
  }

  sync(): void {
    this.buttonTarget.setAttribute(
      'aria-pressed',
      String(!this.videoTarget.muted)
    );
  }
}
